import type { NewsListBlock as NewsListBlockType } from '@/shared/types/blocks';

type NewsListBlockProps = Omit<NewsListBlockType, 'type' | 'id'>;

/**
 * NewsListBlock - 뉴스 리스트
 *
 * Figma 디자인 기준:
 * - 각 아이템: border-top/bottom (#d9dde0), px-16 py-6
 * - 제목: 말줄임 처리, 16px
 * - 우측: "뉴스 바로가기" 버튼 (12px, outline)
 */
export function NewsListBlock({ items, maxItems = 20 }: NewsListBlockProps) {
  const displayItems = items.slice(0, maxItems);

  if (displayItems.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col w-full">
      {displayItems.map((item, index) => (
        <div
          key={`${item.title}-${index}`}
          className={`
            flex items-center justify-between w-full
            px-4 py-1.5
            border-b border-[#d9dde0]
            ${index === 0 ? 'border-t' : ''}
          `}
        >
          {/* 뉴스 제목 */}
          <div className="flex-1 min-w-0 py-2 pr-4">
            <p className="text-base text-black truncate leading-[1.35]">{item.title}</p>
          </div>

          {/* 뉴스 바로가기 버튼 */}
          {item.url && (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="
                shrink-0
                px-2 py-1
                text-xs text-black
                bg-white border border-[#d9dde0] rounded
                hover:bg-gray-50 transition-colors
                leading-[1.35]
              "
            >
              뉴스 바로가기
            </a>
          )}
        </div>
      ))}
    </div>
  );
}
